module.exports = __webpack_public_path__ + "static/media/sala_principal_3.4ef55aad.jpg";